export const getPopupContainer = (selector) => document.querySelector(selector)
  || document.body;
